import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=250aade0"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=250aade0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports